import { Box, styled, Tooltip } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

const LogoSignWrapper = styled(Box)(
  () => `
        width: 52px;
        height: 58px;
        transform: scale(.9);
        padding-left: 2px;
`
);

const LogoTextWrapper = styled(Box)(
  ({ theme }) => `
        padding-left: ${theme.spacing(1)};
`
);

function Logo() {
  const isIndividualAccount = false;
  return (
    <Box
      component="span"
      sx={{
        display: { xs: 'none', sm: 'inline-block' }
      }}
    >
      <Tooltip title={'Version' + ' 2.0'} arrow placement="right">
        <LogoSignWrapper>
          <img height="60" width="100" src="/static/images/logoCircular.png" alt="Home" />
        </LogoSignWrapper>
      </Tooltip>
    </Box>
  );
}

export default Logo;
